module.exports = __webpack_public_path__ + "static/img/kwh_content_bg1.bcc63c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/kwh_content_bg1.png
// module id = B3nV
// module chunks = 1